<template>
  <zen-one
  :showuserinfo="false"
  title="Pentadbiran"
  :crumbs="crumbs"
  >
  <z-page
  title="Tadbir Modul"
  >

  <w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    :width="dialog.width"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-light1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Modul
    </template>

    <w-form
      ref="form"
      v-model="dialog.valid"
      @validate="submit"
      @success="success"
    >

    <z-input label="Label" v-model="form.name" name="name" :validators="[validators.required]" />

    </w-form>


    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
      <w-button
      class="ml1"
      :loading="dialog.loading"
      :disabled="dialog.valid === false"
      @click="$refs.form.validate()"
      >
        Simpan
      </w-button>
    </template>


  </w-dialog>

  <w-card bg-color="z-pale-blue" class="mt4" v-if="module">
    <w-flex class="mt3">
      <div class="xs4">
          <h5 class="fw-semibold m0">
              Label :
          </h5>
          <div class="fw-normal my1 fs-1"> {{ module.name }} </div>
      </div>

      <div class="xs4">
        <h5 class="fw-semibold m0">
            Tarikh Cipta :
        </h5>
        <div class="fw-normal my1 fs-1"> {{ $zutil.dateformat(module.created_at) }} </div>
      </div>
        <div class="xs4">
            <h5 class="fw-semibold m0">
                Tarikh Ubah Akhir :
            </h5>
            <div class="fw-normal my1 fs-1"> {{ $zutil.dateformat(module.updated_at) }} </div>
        </div>
    </w-flex>

  </w-card>

  <z-table
    ref="tbluser"
    title="Senarai Modul"
    :headers="table.headers"
    :items="table.items"
    :meta="table.meta"
    class="white--bg"
  >

    <template #button>
      <w-button
      dark
      class="indigo-dark2--bg ml1 fs-2"
      @click="newrecord()"
      >
        <w-icon class="mr1" xs>fal fa-plus</w-icon> Cipta
      </w-button>
    </template>

    <template #header-label="{ header, label, index }">
      <template v-if="header.key == 'action'">
      <w-icon>fal fa-pencil</w-icon>
      </template>
      <template v-else>
      {{ label }}
      </template>

    </template>

    <template #item-cell.icon="{ item, label, header, index }">
      <w-icon md class="mr1" >{{ item.icon }}</w-icon>
    </template>

    <template #item-cell.action="{ item, label, header, index }">
      <w-flex class="flex justify-center">
        <w-button class="bs fs-2" bg-color="primary-dark1" tile @click="edit(item)">
          <w-icon xs class="mr2">fal fa-pencil</w-icon> Kemaskini
        </w-button>
        <w-button class="fs-2" bg-color="error-dark1" dark tile @click="destroy(item)">
          <w-icon xs class="mr2">fal fa-trash</w-icon> Padam
        </w-button>
        <w-button
          bg-color="info-dark1"
          dark
          tile
          :route="$route('admin.module.show',item.id)"
          class="be fs-2"
        >
          <w-icon xs class="mr2">fal fa-eye</w-icon> Papar
        </w-button>
      </w-flex>
    </template>

  </z-table>

  </z-page>
  </zen-one>
</template>

<script>
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    module: [Array, Object],
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'admin.module',
      reload: true,
      crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Utama', route: '/' },
        { label: 'Pentadbiran', route: '/admin/module' },
        { label: 'Modul', route: '/admin/module' }
      ],
      form: {
        id: 0,
        name: 1,
        module_id: 2,
      }
    }
  },
  methods: {
    // onAfterAdd() {

    // }
  },
  watch: {
    form: {
      handler: function () {
        if(this.module) {
          this.form.module_id = this.module.id
        } else {
          this.form.module_id = 0
        }
      },
      deep: true
    }
  },
  mounted() {
    // override default setting
    this.dialog.width = 500

  },
}
</script>
